/* Back Hero USA — shared UI for the bh-* sections (ported from the approved mockup, 29/09/2026).
   Card rails (all cards while they fit, slider with counter + arrows + swipe/drag when narrower), paged product grid
   (2 rows per page, numbered pages), gallery thumbs + video tile, lazy videos, photo/chart viewer, back to top.
   Everything initialises per element and again when the theme editor re-renders a section (shopify:section:load).
   Horizon scrolls .page-wrapper instead of the window at ≥990px, so scroll listeners use document capture. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const ARR = d => '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + (d < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const scrollTop = () => Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, ($('.page-wrapper') || {}).scrollTop || 0);

  function initRail(rail) {
    if (rail.dataset.bhReady) return; rail.dataset.bhReady = '1';
    const track = $('.bh-rail__track', rail); if (!track) return;
    const items = [...track.children], total = items.length;
    const cnt = $('.bh-rail__count', rail), prev = $('[data-prev]', rail), next = $('[data-next]', rail);
    const geo = () => {
      const cs = getComputedStyle(track), gap = parseFloat(cs.columnGap) || 0;
      const step = total > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
      const view = track.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      return { step: step || 1, vis: Math.max(1, Math.floor((view + gap) / (step || 1) + 0.02)), max: track.scrollWidth - track.clientWidth };
    };
    function update() {
      if (!track.clientWidth) return;
      const { step, vis, max } = geo();
      rail.classList.toggle('is-static', max <= 2);
      if (max <= 2 || !cnt) return;
      let first = track.scrollLeft >= max - 2 ? total - vis : Math.round(track.scrollLeft / step);
      first = Math.max(0, Math.min(first, total - vis));
      cnt.innerHTML = '<b>' + (vis > 1 ? (first + 1) + '–' + (first + vis) : first + 1) + '</b> / ' + total;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    const go = dir => { const { step, vis } = geo(); track.scrollBy({ left: dir * step * vis, behavior: 'smooth' }); };
    prev && prev.addEventListener('click', () => go(-1));
    next && next.addEventListener('click', () => go(1));
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    let down = false, moved = false, sx = 0, sl = 0;
    track.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button || rail.classList.contains('is-static')) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
    window.addEventListener('pointermove', e => {
      if (!down) return; const dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-drag'); }
      if (moved) track.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', () => {
      if (!down) return; down = false; if (!moved) return;
      const { step } = geo(); track.scrollTo({ left: Math.round(track.scrollLeft / step) * step, behavior: 'smooth' });
      setTimeout(() => track.classList.remove('is-drag'), 400);
    });
    track.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', e => e.preventDefault());
    update();
  }

  function initPgrid(pg) {
    if (pg.dataset.bhReady) return; pg.dataset.bhReady = '1';
    const grid = $('.bh-pgrid__grid', pg), nav = $('.bh-pager', pg); if (!grid || !nav) return;
    const items = [...grid.children];
    let page = 0, cols = 0;
    const pages = () => Math.max(1, Math.ceil(items.length / (cols * 2)));
    function render(anim) {
      if (!cols) return;
      const n = pages(); page = Math.max(0, Math.min(page, n - 1));
      items.forEach((it, i) => { it.hidden = Math.floor(i / (cols * 2)) !== page; });
      nav.hidden = n < 2;
      nav.innerHTML = n < 2 ? '' : '<button type="button" class="bh-pager__arr" data-go="-1" aria-label="Previous page"' + (page ? '' : ' disabled') + '>' + ARR(-1) + '</button>'
        + Array.from({ length: n }, (_, i) => '<button type="button" data-page="' + i + '"' + (i === page ? ' aria-current="page"' : '') + '>' + (i + 1) + '</button>').join('')
        + '<button type="button" class="bh-pager__arr" data-go="1" aria-label="Next page"' + (page < n - 1 ? '' : ' disabled') + '>' + ARR(1) + '</button>';
      if (anim) { grid.classList.remove('is-turn'); void grid.offsetWidth; grid.classList.add('is-turn'); }
    }
    function measure() { const c = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length; if (c && c !== cols) { cols = c; render(false); } }
    nav.addEventListener('click', e => { const b = e.target.closest('button'); if (!b || b.disabled) return; page = b.dataset.page != null ? +b.dataset.page : page + +b.dataset.go; render(true); });
    let x0 = null;
    grid.addEventListener('pointerdown', e => { x0 = e.clientX; });
    grid.addEventListener('pointerup', e => {
      if (x0 === null) return; const dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) < 50 || pages() < 2) return;
      const np = Math.max(0, Math.min(pages() - 1, page + (dx < 0 ? 1 : -1)));
      if (np !== page) { page = np; render(true); }
    });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(grid);
    measure();
  }

  // gallery: thumbs switch the main image; a [data-video] thumb plays the section's video in the main frame
  document.addEventListener('click', e => {
    const t = e.target.closest('.bh-gallery__thumbs img, .bh-gallery__thumbs [data-thumb]'); if (!t) return;
    const g = t.closest('.bh-gallery'); if (!g) return;
    const img = $('[data-main]', g), vid = $('[data-main-video]', g), isVid = !!t.closest('[data-video]');
    if (isVid && vid) { if (vid.dataset.poster && !vid.getAttribute('poster')) vid.setAttribute('poster', vid.dataset.poster); img.hidden = true; vid.hidden = false; vid.play().catch(() => {}); }
    else {
      if (vid) { vid.pause(); vid.hidden = true; }
      img.hidden = false;
      const src = t.dataset.full || t.currentSrc || t.src;
      // a thumb with data-srcset keeps the main photo responsive (phones load ~1000w, not 1200w, per tap)
      if (t.dataset.srcset) img.srcset = t.dataset.srcset; else img.removeAttribute('srcset');
      img.src = src; if (t.alt) img.alt = t.alt;
    }
    $$('.bh-gallery__thumbs img', g).forEach(x => x.classList.toggle('is-on', x === t || x.parentNode === t));
  });

  // videos run ahead (owner 30/09: "tất cả hình hay video cho các trang giờ chạy trước hết.. đừng chạy khi tới gần nữa"):
  // - right after the first view every poster is set (sections print data-poster, not poster);
  // - once the images are in (assets/bh-img-loader.js sends 'bh:images-done'; at the latest 12 s after the first view)
  //   the short clips (data-ahead, ≤ 20 s) start buffering, so they are ready long before the shopper gets there;
  // - a muted loop plays from ~1400px before it reaches the screen and pauses again when it is that far away (battery).
  //   A short clip in a rail plays as soon as the rail is that close, whichever card is showing; a long clip (no
  //   data-ahead: Shopify only offers its 1080p file to the theme) streams only while its own card is near.
  // At ≥990px Horizon scrolls .page-wrapper: an observer on the viewport is clipped by it (rootMargin ignored), so the
  // observer uses .page-wrapper as root there and is rebuilt when the layout switches.
  const SQUEEZE = matchMedia('(min-width: 990px)');
  const setPoster = v => { if (v.dataset.poster && !v.getAttribute('poster')) v.setAttribute('poster', v.dataset.poster); };
  const buffer = v => { if (v.preload === 'none') v.preload = 'auto'; };
  // owner 29/10/2026 ("Yes, change videos"): on phones / tablets only the first gallery video buffers ahead; every other
  // clip downloads when the shopper scrolls near it (the ~1400px play observer below). Photos keep the 30/09 rule.
  const PHONE = matchMedia('(max-width: 1024px), (pointer: coarse)').matches;
  const aheadOk = v => !PHONE || !!v.closest('.bh-gallery');
  const playable = el => el.tagName === 'VIDEO' ? [el] : $$('video[data-lazy][data-ahead]', el);
  const onPlay = es => es.forEach(en => playable(en.target).forEach(v => {
    if (en.isIntersecting && !v.closest('[hidden]')) { setPoster(v); if (v.preload === 'none' && v.dataset.src && !v.src) v.src = v.dataset.src; v.play().catch(() => {}); } else v.pause();
  }));
  let io = null, postersOn = false, bufferOn = false;
  function makeObservers() {
    if (!('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    $$('[data-bh-vrail]').forEach(r => { delete r.dataset.bhVrail; });
    io = new IntersectionObserver(onPlay, { root: (SQUEEZE.matches && $('.page-wrapper')) || null, rootMargin: '1400px 0px' });
  }
  function watchVideo(v) {
    if (postersOn) setPoster(v);
    if (bufferOn && v.matches('[data-ahead]') && aheadOk(v)) buffer(v);
    if (!v.matches('[data-lazy]')) return;
    if (!io) { setPoster(v); return; }
    const rail = v.matches('[data-ahead]') && v.closest('[data-rail]');
    if (!rail) io.observe(v);
    else if (!rail.dataset.bhVrail) { rail.dataset.bhVrail = '1'; io.observe(rail); }
  }
  (() => {
    const posters = () => { if (postersOn) return; postersOn = true; $$('video[data-poster]').forEach(setPoster); setTimeout(buffers, 12000); };
    const buffers = () => { if (bufferOn) return; bufferOn = true; $$('video[data-ahead]').filter(aheadOk).forEach(buffer); };
    addEventListener('bh:images-done', () => { posters(); buffers(); }, { once: true });
    const hero = $('img[fetchpriority="high"]');
    if (!hero || hero.complete) setTimeout(posters, 300);
    else { hero.addEventListener('load', posters, { once: true }); hero.addEventListener('error', posters, { once: true }); }
    setTimeout(posters, 4000);
  })();
  // images: loaded in the background after the first view by assets/bh-img-loader.js (self-contained, 30/09/2026)

  makeObservers();
  const rewatch = () => { makeObservers(); $$('video[data-bh-io]').forEach(watchVideo); };
  if (SQUEEZE.addEventListener) SQUEEZE.addEventListener('change', rewatch); else if (SQUEEZE.addListener) SQUEEZE.addListener(rewatch);

  // photo / size-chart viewer
  let lb = null, lbList = [], lbI = 0, lbFrom = null, lbX = null, lbSwiped = false;
  function ensureLb() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'bh-lb'; lb.hidden = true; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Image viewer');
    lb.innerHTML = '<img alt=""><button type="button" class="bh-lb__x" aria-label="Close">×</button><button type="button" class="bh-lb__nav bh-lb__nav--prev" aria-label="Previous image">' + ARR(-1) + '</button><button type="button" class="bh-lb__nav bh-lb__nav--next" aria-label="Next image">' + ARR(1) + '</button><span class="bh-lb__count"></span>';
    document.body.appendChild(lb);
    lb.addEventListener('pointerdown', e => { lbX = e.clientX; lbSwiped = false; });
    lb.addEventListener('pointerup', e => { if (lbX === null) return; const dx = e.clientX - lbX; lbX = null; if (Math.abs(dx) > 50) { lbSwiped = true; lbShow(lbI + (dx < 0 ? 1 : -1)); } });
    lb.addEventListener('click', e => {
      if (lbSwiped) { lbSwiped = false; return; }
      if (e.target.closest('.bh-lb__nav--prev')) lbShow(lbI - 1);
      else if (e.target.closest('.bh-lb__nav--next')) lbShow(lbI + 1);
      else if (e.target === lb || e.target.closest('.bh-lb__x')) lbClose();
    });
    return lb;
  }
  const lbShow = i => { lbI = (i + lbList.length) % lbList.length; const im = lbList[lbI]; $('img', lb).src = im.dataset.full || im.currentSrc || im.src; $('img', lb).alt = im.alt; $('.bh-lb__count', lb).textContent = (lbI + 1) + ' / ' + lbList.length; };
  const lbClose = () => { lb.hidden = true; document.documentElement.style.overflow = ''; if (lbFrom) lbFrom.focus(); };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-zoom]'); if (!b) return;
    ensureLb();
    lbList = $$('[data-zoom] img', b.closest('[data-zoom-group]') || b.parentNode); lbFrom = b;
    lb.hidden = false; lb.classList.toggle('is-single', lbList.length < 2); document.documentElement.style.overflow = 'hidden';
    lbShow(Math.max(0, lbList.indexOf($('img', b)))); $('.bh-lb__x', lb).focus();
  });
  document.addEventListener('keydown', e => {
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') lbClose(); else if (e.key === 'ArrowLeft') lbShow(lbI - 1); else if (e.key === 'ArrowRight') lbShow(lbI + 1);
  });

  // back to top
  const totop = () => { const on = scrollTop() > 300; $$('.bh-totop').forEach(b => b.classList.toggle('is-show', on)); };
  document.addEventListener('scroll', () => requestAnimationFrame(totop), { passive: true, capture: true });
  document.addEventListener('click', e => {
    if (!e.target.closest('.bh-totop')) return;
    const behavior = matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, behavior }); const pw = $('.page-wrapper'); if (pw) pw.scrollTo({ top: 0, behavior });
  });

  // navigation feedback (30/09/2026, owner: menu / shop tabs respond slowly on iPhone): from the tap until the next page
  // paints, a slim brand-blue bar runs along the top and the link tapped shows the Add to cart ring — buttons and tabs
  // swap their label for the ring, product cards show it over the photo, text links get it after the text.
  // Only same-site links that really leave the page: not hash links, new tabs / modifier clicks, downloads, /cart
  // (drawer), checkout / account, or anything another script already handled (defaultPrevented). A page restored from
  // the back-forward cache is cleared on pageshow; a safety timer clears it if no navigation happens.
  let navTimer = 0;
  const NO_NAV = /^\/(cart|checkout|checkouts|account|customer_authentication|services|apps|cdn)(\/|$)/;
  function navClear() {
    clearTimeout(navTimer);
    $$('.bh-navspin').forEach(s => s.remove());
    $$('.bh-navbusy').forEach(a => { a.classList.remove('bh-navbusy', 'bh-navbusy--btn'); a.style.removeProperty('--bh-spin-c'); });
    $$('.bh-navbar').forEach(b => b.classList.remove('is-on'));
  }
  function navStart(a) {
    navClear();
    // a link inside an open modal dialog (cart drawer) sits in the top layer: the bar goes in there, no ring
    const host = a.closest('dialog[open]') || document.body;
    let bar = [...host.children].find(c => c.classList.contains('bh-navbar'));
    if (!bar) { bar = document.createElement('div'); bar.className = 'bh-navbar'; bar.setAttribute('aria-hidden', 'true'); host.appendChild(bar); }
    void bar.offsetWidth; bar.classList.add('is-on');
    navTimer = setTimeout(navClear, 12000);
    if (host !== document.body) return;
    // a custom element, so no kit rule for spans (tab count bubble, card labels) restyles the ring
    const spin = document.createElement('bh-spin'); spin.className = 'bh-navspin'; spin.setAttribute('aria-hidden', 'true');
    const media = $('.bh-prod__img', a);
    const icon = a.lastElementChild;
    if (a.matches('.bh-btn, .bh-shop-tab, .button, .bh-pager a')) {
      a.style.setProperty('--bh-spin-c', getComputedStyle(a).color);
      a.classList.add('bh-navbusy', 'bh-navbusy--btn'); a.appendChild(spin);
    } else if (media) {
      spin.classList.add('bh-navspin--media'); a.classList.add('bh-navbusy'); media.appendChild(spin);
    } else if (icon && icon.matches('i, span') && icon.textContent.trim() && icon.textContent.trim().length <= 2) {
      // a trailing arrow ("→" on the product-used chip): the ring takes its place
      icon.style.setProperty('--bh-spin-c', getComputedStyle(icon).color);
      a.classList.add('bh-navbusy'); icon.classList.add('bh-navbusy', 'bh-navbusy--btn'); icon.appendChild(spin);
    } else if (a.textContent.trim()) {
      // text links (header menu, menu drawer, "Read more…"): the ring floats just after the last line of text, fixed on
      // screen, so nothing in the menu moves or wraps
      const own = el => [...el.childNodes].some(n => n.nodeType === 3 && n.textContent.trim());
      const tgt = [...a.querySelectorAll('*')].reverse().find(el => !el.closest('svg') && own(el)) || a;
      const rg = document.createRange(); rg.selectNodeContents(tgt);
      const rs = [...rg.getClientRects()].filter(r => r.width); const r = rs[rs.length - 1] || tgt.getBoundingClientRect();
      const cs = getComputedStyle(tgt), px = Math.max(12, Math.min(22, parseFloat(cs.fontSize) || 16));
      const left = Math.min(r.right + px * 0.4, innerWidth - px * 1.4);
      spin.classList.add('bh-navspin--fixed');
      spin.style.cssText = 'left:' + Math.round(left) + 'px;top:' + Math.round(r.top + r.height / 2 - px * 0.425) + 'px;width:' + (px * 0.85).toFixed(1) + 'px;height:' + (px * 0.85).toFixed(1) + 'px;color:' + cs.color;
      a.classList.add('bh-navbusy'); document.body.appendChild(spin);
    }
  }
  window.addEventListener('click', e => {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    if ((a.target && a.target !== '_self') || a.hasAttribute('download') || a.closest('[data-no-nav-spin]')) return;
    let u; try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin !== location.origin || !/^https?:$/.test(u.protocol) || NO_NAV.test(u.pathname)) return;
    if (u.pathname === location.pathname && u.search === location.search && (u.hash || a.getAttribute('href').charAt(0) === '#')) return;
    navStart(a);
  });
  window.addEventListener('pageshow', navClear);

  // first tap always counts in the header (30/09/2026, owner: on iPhone Safari the menu needed two taps). iOS turns a
  // tap into a "hover" and drops its click when the page changes while the tap is being checked (Horizon activates the
  // header menu on pointerenter, the drawer items fade in one by one, apps mutate the page...). For the burger, header
  // menu links, drawer links and the cart button only: when a real tap (short, still) ends on one and no click follows
  // within 400ms, the click is dispatched for it; a late native click on the same control within 1s is then swallowed,
  // so nothing ever happens twice. Nothing runs on touchstart except remembering the control; no layout is touched.
  const TAP = '#header-component a[href], #header-component summary, #header-component button, .menu-drawer a[href], .menu-drawer summary, .menu-drawer button';
  let tapDown = null, tapWait = null, tapSynth = null;
  document.addEventListener('touchstart', e => {
    const el = e.touches.length === 1 && e.target.closest && e.target.closest(TAP);
    tapDown = el ? { el, x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now(), moved: false } : null;
  }, { passive: true, capture: true });
  document.addEventListener('touchmove', e => {
    if (tapDown && (Math.abs(e.touches[0].clientX - tapDown.x) > 10 || Math.abs(e.touches[0].clientY - tapDown.y) > 10)) tapDown.moved = true;
  }, { passive: true, capture: true });
  document.addEventListener('touchcancel', () => { tapDown = null; }, { passive: true, capture: true });
  document.addEventListener('touchend', () => {
    const d = tapDown; tapDown = null;
    if (!d || d.moved || Date.now() - d.t > 600) return;
    if (tapWait) clearTimeout(tapWait.timer);
    const w = { el: d.el };
    w.timer = setTimeout(() => {
      if (tapWait !== w) return; tapWait = null;
      const el = w.el;
      if (!el.isConnected || el.closest('[inert]') || !el.getClientRects().length) return;
      tapSynth = { el, until: Date.now() + 1000 };
      el.click();
    }, 400);
    tapWait = w;
  }, { passive: true, capture: true });
  window.addEventListener('click', e => {
    const hit = el => el === e.target || el.contains(e.target);
    if (tapWait && hit(tapWait.el)) { clearTimeout(tapWait.timer); tapWait = null; return; }
    if (tapSynth && e.isTrusted && Date.now() < tapSynth.until && hit(tapSynth.el)) { e.preventDefault(); e.stopImmediatePropagation(); tapSynth = null; }
  }, true);

  function init(root = document) {
    $$('[data-rail]', root).forEach(initRail);
    $$('[data-pgrid]', root).forEach(initPgrid);
    $$('video[data-lazy], video[data-poster]', root).forEach(v => { if (!v.dataset.bhIo) { v.dataset.bhIo = '1'; watchVideo(v); } });
    totop();
  }
  window.BH = Object.assign(window.BH || {}, { init, $, $$, scrollTop });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
